import type { SparkIntent } from '@/core/data/spark/spark.interface';

export const getEnabledIntentsSorted = (intents: SparkIntent[]): SparkIntent[] => {
  return [...intents].filter((intent) => !intent.isDisabled).sort((a, b) => a.date.localeCompare(b.date));
};

export const findEnabledIntentByDate = (intents: SparkIntent[], date: string): SparkIntent | null => {
  return getEnabledIntentsSorted(intents).find((intent) => intent.date === date) || null;
};

export const findIntentByDate = (intents: SparkIntent[], date: string): SparkIntent | null => {
  return intents.find((intent) => intent.date === date) || null;
};

export const getEarliestEnabledIntent = (intents: SparkIntent[]): SparkIntent | null => {
  return getEnabledIntentsSorted(intents)[0] || null;
};
